<claas-horizontal-scroll-helper
  [scrollTarget]="scrollContainer"
></claas-horizontal-scroll-helper>
<div #scrollContainer class="products-compare-arguments">
  <div class="compare-container">
    <table class="compare-table">
      <tbody class="compare-table-body">
        <tr class="row header-row">
          <th class="label-col-head">
            <!-- Empty on small screens, holds toggler position on large screens -->
            <claas-toggle
              id="toggle-button"
              class="favorites-toggler desktop-toggler"
              [disabled]="false"
              [label]="'pia.shared.toggleFavouritesButtonLabel' | translate"
              [checked]="!!showFavoriteArgumentsStatus()"
              [required]="false"
              [disableRipple]="true"
              [inputTop]="false"
              [size]="toggleSize.SMALL"
              [truncatedText]="true"
              (changed)="handleToggleFavouriteArgumentsChange($event)"
            ></claas-toggle>
          </th>
          <th class="arguments-cols" colspan="2">
            <claas-toggle
              id="toggle-button-mobile"
              class="favorites-toggler mobile-toggler"
              [disabled]="false"
              [label]="'pia.shared.toggleFavouritesButtonLabel' | translate"
              [checked]="!!showFavoriteArgumentsStatus()"
              [required]="false"
              [disableRipple]="true"
              [inputTop]="false"
              [size]="toggleSize.SMALL"
              [truncatedText]="true"
              (changed)="handleToggleFavouriteArgumentsChange($event)"
            ></claas-toggle>

            <table class="arguments-table">
              <tbody class="arguments-table-body">
                <tr class="argument-row selects-row">
                  <td class="argument-col-head">
                    <claas-product-compare-select
                      class="product-select"
                    ></claas-product-compare-select>
                  </td>
                  <td class="argument-col-head">
                    <claas-competitor-compare-select
                      class="competitor-select"
                    ></claas-competitor-compare-select>
                  </td>
                </tr>
              </tbody>
            </table>
          </th>
        </tr>
        @for (
          argumentsComparisonGroup of argumentsComparison();
          track argumentsComparisonGroup.title
        ) {
          <tr class="row">
            <td class="label-col">
              <h3 class="row-label font-xs">
                <span class="row-label-text">{{
                  argumentsComparisonGroup.title
                }}</span>
              </h3>
            </td>
            <td class="arguments-cols" colspan="2">
              <table class="arguments-table">
                <tbody class="arguments-table-body">
                  @for (
                    productArgument of argumentsComparisonGroup.productArguments;
                    track productArgument.ID;
                    let index = $index
                  ) {
                    <tr class="argument-row">
                      <td
                        class="argument-col product-argument-col"
                        [class.no-title]="!productArgument?.Title"
                        (mouseenter)="
                          setProductArgumentHover(productArgument.ID || null)
                        "
                        (mouseleave)="setProductArgumentHover(null)"
                        (click)="
                          onProductArgumentRowClick($event, productArgument)
                        "
                      >
                        <div class="argument-content">
                          <div class="argument-rating">
                            <claas-argument-rating-icon
                              [rating]="productArgument.Rating"
                            ></claas-argument-rating-icon>
                          </div>
                          <div class="argument-wrap">
                            @if (productArgument?.Title) {
                              <a
                                [routerLink]="[
                                  `./detail/product/${productArgument.ID}`,
                                ]"
                                class="argument-link"
                              >
                                <h4 class="argument-title font-xs">
                                  {{ productArgument.Title }}
                                </h4>
                              </a>
                            } @else {
                              <div class="argument-link no-link">
                                <h4 class="argument-title font-xs">-</h4>
                              </div>
                            }
                            @if (productArgument?.Exclusive) {
                              <div class="badge font-3xs">
                                {{
                                  "features.productArguments.exclusiveFlag"
                                    | translate
                                    | uppercase
                                }}
                              </div>
                            }
                          </div>
                        </div>
                        @if (productArgument.ID) {
                          <button
                            [attr.inert]="
                              isProductArgumentFavorite()(productArgument.ID) ||
                              hoveredProductArgument() === productArgument.ID
                                ? undefined
                                : ''
                            "
                            (click)="addArgumentToFavorites(productArgument.ID)"
                            [ngClass]="{
                              'favorite-btn icon-only-button small': true,
                              blacken: isProductArgumentFavorite()(
                                productArgument.ID
                              ),
                            }"
                          >
                            <claas-icon
                              [id]="''"
                              [iconId]="'649123'"
                              [namespace]="'storybook'"
                              [iconStyle]="'bold'"
                              [size]="24"
                              [alt]="''"
                              [iconName]="'favorites'"
                              [removeDefaultColor]="true"
                              [class]="'favorite-icon'"
                            >
                            </claas-icon>
                          </button>
                        }
                      </td>
                      <td
                        class="argument-col competitor-argument-col"
                        [class.no-title]="
                          !argumentsComparisonGroup?.competitorArguments?.[
                            index
                          ]?.Title
                        "
                        (click)="
                          onProductArgumentRowClick(
                            $event,
                            $safeNavigationMigration(
                              argumentsComparisonGroup?.competitorArguments?.[
                                index
                              ]
                            )
                          )
                        "
                        (mouseenter)="
                          setProductArgumentHover(
                            argumentsComparisonGroup?.competitorArguments?.[
                              index
                            ]?.ID || null
                          )
                        "
                        (mouseleave)="setProductArgumentHover(null)"
                      >
                        <div class="argument-rating">
                          @if (
                            argumentsComparisonGroup?.competitorArguments?.[
                              index
                            ]?.Title
                          ) {
                            <claas-argument-rating-icon
                              [rating]="
                                $safeNavigationMigration(
                                  argumentsComparisonGroup
                                    ?.competitorArguments?.[index]?.Rating
                                )
                              "
                            ></claas-argument-rating-icon>
                          }
                        </div>
                        <div class="argument-wrap">
                          @if (
                            argumentsComparisonGroup?.competitorArguments?.[
                              index
                            ]?.Title
                          ) {
                            <a
                              [routerLink]="[
                                `./detail/competitor/${$safeNavigationMigration(argumentsComparisonGroup?.competitorArguments?.[index]?.ID)}`,
                              ]"
                              class="argument-link"
                            >
                              <h4 class="argument-title font-xs">
                                {{
                                  argumentsComparisonGroup.competitorArguments[
                                    index
                                  ].Title
                                }}
                              </h4>
                            </a>
                          } @else {
                            <div class="argument-link no-link">
                              <h4 class="argument-title font-xs">&ndash;</h4>
                            </div>
                          }
                          @if (
                            argumentsComparisonGroup?.competitorArguments?.[
                              index
                            ]?.Exclusive
                          ) {
                            <div class="badge font-3xs">
                              {{
                                "features.productArguments.exclusiveFlag"
                                  | translate
                                  | uppercase
                              }}
                            </div>
                          }
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <claas-main-modal-dialog
    [(show)]="showMainModal"
    [navigateOnBackdropClick]="`/pia/${countryID()}/${languageID()}/${year()}/product/${productID()}/arguments/${productDetailID()}/comparison/${competitorID()}`"
  >
    <router-outlet></router-outlet>
  </claas-main-modal-dialog>
</div>
